export const REFRESH_STORE_DATA = 'REFRESH_STORE_DATA';
export const INITIALIZE_STORE_DATA = 'INITIALIZE_STORE_DATA';